import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalsenttouser from './Modalsenttouser';
import Modalarticlefacultybnrobtwo from './Modalarticlefacultybnrobtwo';
//import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';
import Swal from 'sweetalert2'


export default class Commentbnlistforadminfaculty extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentbnforadmin:[],

   id_bn:'',
   bn_comment:'',
   
}


this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
//  this.props.selectex();
}




 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                      bn_comment:this.props.bn_comment
         })
      setTimeout(() => {
       
         Axios.get('https://conference.kpru.ac.th/PHPAPI/selectcommentforadminfaculty.php?id_send='+this.props.id_send)
        .then(res => {
          console.log(res);
       
          this.setState({ commentbnforadmin: res.data})
          if (res.data.length !== 0) {
            this.setState({ id_bn: res.data[0].id_bn})
          }
        }) 

      }, 0);

  }


  list() {
      setTimeout(() => {
         Axios.get('https://conference.kpru.ac.th/PHPAPI/selectcommentforadminfaculty.php?id_send='+this.props.id_send)
        .then(res => {
          console.log(res);
          this.setState({ commentbnforadmin: res.data})
          if (res.data.length !== 0) {
            this.setState({ id_bn: res.data[0].id_bn})
          }
        }) 
      }, 0);
  }



  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_send", this.state.id_send);
      datafrm.append("bn_comment", '1');

//อัพเดทสถานะ
  Axios.post("https://conference.kpru.ac.th/PHPAPI/updatestatuspassbn.php",datafrm)
    .then(res => {
      console.log("response: ", res)

      if (res.data.status = 'success999') {
   
        Swal.fire({
         title: 'อัพเดทสถานะและแจ้งผู้เขียนสำเร็จ',
         text: "Successfully updated status and notified author.",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.list()
             window.location.reload(false);
           //  this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
 
  
   })

 
}, 1000);

  }



    render() {
      //  console.log(this.state.id_bn)

        return (
            <>
                  <Modalarticlefacultybnrobtwo id_send={this.state.id_send} id_bn={this.state.id_bn} list={this.list} />
           <MDBTable bordered>
      <MDBTableHead color="blue-grey lighten-3" >
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์บทความที่ส่งตรวจ</th>
          <th>วันที่ส่งตรวจ</th>
          <th>ไฟล์ข้อเสนอแนะ</th>
          <th>วันที่ส่งกลับ</th>
          <th>สถานะส่งกลับจากบรรณาธิการ</th>
          <th>แจ้งผู้ส่งบทความ</th>
          <th>ผู้ส่งบทความ ปรับแก้กลับ</th>
          <th>สถานะ</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentbnforadmin.map((commentbnforadmin,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td><a href={`https://conference.kpru.ac.th/PHPAPI/closeacticle/${commentbnforadmin.fileword}`}  target="_blank"><p className="indigo-text"><MDBIcon far icon="file-word" /> ไฟล์ที่ส่งตรวจ</p> </a></td>
                        <td>{commentbnforadmin.date_sentbn}</td>
                        <td>{commentbnforadmin.filewordcomment_bn !== null ? <><a  href={`https://conference.kpru.ac.th/PHPAPI/commentbn/${commentbnforadmin.filewordcomment_bn}`}  target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ</p> </a></>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td>{commentbnforadmin.date_senbacktbn !== null ?<>{commentbnforadmin.date_senbacktbn}</>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td>{commentbnforadmin.filewordcomment_bn !== null ?<>
                        ส่งกลับแล้ว
                        </>:<>
                         รอบรรณาธิการตรวจสอบ
                        </>}
                        </td>
                        <td>
                            {commentbnforadmin.status_show === '1' ? <><MDBIcon icon="volume-up" /> แจ้งแล้ว</>:<>
                              {commentbnforadmin.filewordcomment_bn !== null?<>
                               <Modalsenttouser id_send={commentbnforadmin.id_send} id_comment={commentbnforadmin.id_comment} id_bn={commentbnforadmin.id_bn} list={this.list}  />
                              </>:<>
                                 รอบรรณาธิการตรวจสอบ
                              </>}
                           
                            </>}
                          
                        </td>
                        <td>{commentbnforadmin.sentbackeditword !== null ?<>
                            <MDBBtn color="indigo" size="sm" href={`https://conference.kpru.ac.th/PHPAPI/usereditback/${commentbnforadmin.sentbackeditword}`}  target="_blank"><MDBIcon icon="arrow-alt-circle-down" /> WORD</MDBBtn>
                        {/* {commentbnforadmin.sentbackeditword} */}
                        </>:<> <p className="orange-text">อยู่ระหว่างดำเนินการ</p> </>}</td>
                        <td>{commentbnforadmin.statuscomment_bn ==='1' ?<><p className="teal-text">ผ่าน</p></>:<>
                        {commentbnforadmin.statuscomment_bn ==='0' ?<><p className="red-text">ไม่ผ่าน</p></>:<><p className="orange-text">อยู่ระหว่างดำเนินการ</p> </>}
                        </>}</td>
                        </tr>
                      )}
      </MDBTableBody>
    </MDBTable>
    {this.state.bn_comment === '1'?<><h4 className='text-center'>ผ่านขั้นตอนบรรณาธิการแล้ว</h4></>:<> <div className='text-center'> <MDBBtn color="success" onClick={this.handleSubmit}>ผ่านขั้นตอนบรรณาธิการ</MDBBtn> </div></>}
   
   
    

          </>
          
        )
    }
}


